import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const contentsStyle = css`
  display: flex;
  flex-direction: column;
  margin-inline: auto;
  max-width: 770px;
  padding-block: 24px;
  row-gap: 24px;
  width: 100%;

  ${MEDIA_QUERY_FOR_SP} {
    padding-inline: 20px;
  }
`;

export const heading2style = css`
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
`;

export const filterSelectStyle = css`
  background-color: #fff;
  border-radius: 4px;
  color: #000;
  font-size: 14px;
  padding: 8px 36px 8px 8px;
  width: 100%;
`;
